export default __webpack_public_path__ + "static/media/Group1107.c91eb9fa.svg";